import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShippingComponent } from './shipping.component';
import { ShippingRoutingModule } from './shipping-routing.module';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { QuantityBreaksComponent } from './quantity-breaks/quantity-breaks.component';
import { CarrierMethodsComponent } from './carrier-methods/carrier-methods.component';
import { TimeEstimatesComponent } from './time-estimates/time-estimates.component';



@NgModule({
  declarations: [ShippingComponent, QuantityBreaksComponent, CarrierMethodsComponent, TimeEstimatesComponent],
  imports: [
    CommonModule,
    ShippingRoutingModule,
    UbsViewContainersModule
  ]
})
export class ShippingModule { }
